import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography'
import SideStyle from '../style/sideStyle';
// import Control from '../store/control';
import Param from '../store/param';
// import { Start, Check, GetSTL, GetLog } from "../fileIO/post";
// import { POLLING_INTERVAL1 } from '../store/global';


const FormHoleinalDeviceFinalStep = () => {
  const style      = SideStyle();
  const rein       = Param.Get("reinforth");
  const SetParam   = Param.Get("SetParam");
  // const SetControl = Control.Get("SetControl");

  const onClear = () => {
    // SetControl(s => {s.meshSocketF26 = null});
    SetParam(s => {s.reinforth.step = 0});
  };

  const handleValue = (e) => {
    SetParam(s => {s.reinforth[e.target.name] = Number(e.target.value)});
  };

  // useEffect(() => {
  //   SetControl(s => {s.flgLegClickable = false, s.flgSocketClickable = false});
  // });

  return (
    <div className={style.outside}>
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>

        {/* Thickness */}
        <Grid item xs={12} className={style.subcategory}>Thickness</Grid>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Typography>Outer thickness</Typography>
          </Grid>
          <Grid item xs={4}>
            <FormControl>
              <Input
                type='number'
                name='outer_thickness'
                value={rein.outer_thickness}
                onChange={handleValue}
                endAdornment={<InputAdornment position='end'>mm</InputAdornment>}
                variant='filled'
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Typography>Inner thickness</Typography>
          </Grid>
          <Grid item xs={4}>
            <FormControl>
              <Input
                type='number'
                name='outer_thickness'
                value={rein.inner_thickness}
                onChange={handleValue}
                endAdornment={<InputAdornment position='end'>mm</InputAdornment>}
                variant='filled'
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Typography>Smooth</Typography>
          </Grid>
          <Grid item xs={4}>
            <FormControl>
              <Input
                type='number'
                name='smooth'
                value={rein.smooth}
                onChange={handleValue}
                variant='filled'
              />
            </FormControl>
          </Grid>
        </Grid>

        {/* Reinforth */}
        <Grid item xs={12} className={style.subcategory}>Reinforth</Grid>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Typography>Thickness</Typography>
          </Grid>
          <Grid item xs={4}>
            <FormControl>
              <Input
                type='number'
                name='reinforth_thickness'
                value={rein.reinforth_thickness}
                onChange={handleValue}
                variant='filled'
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Typography>Width</Typography>
          </Grid>
          <Grid item xs={4}>
            <FormControl>
              <Input
                type='number'
                name='reinforth_width'
                value={rein.reinforth_width}
                onChange={handleValue}
                variant='filled'
              />
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Button className={style.button} onClick={submitF26}>Apply</Button>
          </Grid>
          <Grid item xs={6}>
            <Button className={style.button} onClick={onClear} disabled={(rein.step==0)}>Clear Socket</Button>
          </Grid>
        </Grid>

      </Grid>
    </div>
  );
}
export default FormHoleinalDeviceFinalStep;
